import { gql } from "@apollo/client";

export const GET_POPUPS = gql`
  query Popups($where: PopupWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
    popups(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
        total
        data {
            id
            title
            detail
            animation
            isPublished
            position
            createdAt
            updatedAt
            note
        }
    }
}
`;